import { Box } from '@factorialco/deprecated-design-system'

import { Expensable } from 'modules/expenses/types/Expensable'
import { JournalEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab'
import { JournalDraftEntryTab } from 'modules/finance/components/JournalsEntry/JournalEntryTab/JournalDraftEntry'

import { useExpensableJournalEntries } from '../hooks/useExpensableJournalEntries'

interface Props {
  expensable: Expensable
}

const Accounting = ({ expensable }: Props) => {
  const { journalDraftEntry, journalEntry } = useExpensableJournalEntries({ expensable })

  return (
    <Box padding="s24" gap="s40">
      {journalDraftEntry && (
        <Box paddingTop={'s16'}>
          <JournalDraftEntryTab
            journalDraftEntry={journalDraftEntry}
            legalEntity={journalDraftEntry.legalEntity}
            currency={expensable.currency}
          />
        </Box>
      )}

      {journalEntry && (
        <Box paddingTop={'s16'}>
          <JournalEntryTab
            journalEntry={journalEntry}
            legalEntity={journalEntry.legalEntity}
            currency={expensable.currency}
          />
        </Box>
      )}
    </Box>
  )
}

export default Accounting
